import { SettingsGroup } from "./types";

/** Reserve Activities (12) and Reserve Dining (13) — add group definitions here. */
export const reserveSettingsGroups: SettingsGroup[] = [];
